<template>
  <div class="white_container reserved_container">
    <h4>NIVELUL {{userLevel}}</h4>
    <h2>Orar în pregătire</h2>
    <p>Managerul nostru îți creează orarul. Te vom anunța în cel mai scurt timp când ai un orar. Fii pe fază!</p>
    <img src="../../../../assets/img/shedule-flow-svg-picture.svg" alt="">
  </div>
</template>

<script>
  import Countdown from '../Countdown';
  import { mapGetters } from 'vuex';

  export default {
    name: "Scheduled",
    components: {
      Countdown
    },
    data: function () {
      return {
        isSoonLesson: -1,
      }
    },
    computed: {
      ...mapGetters({
        userLevel: 'user/level',
      }),
    },
    mounted() {


    },
    methods: {

    }
  }
</script>

<style scoped lang="scss">
  .reserved_container{
    text-align: center;
    padding: 6rem 1.5rem 4rem;
    margin-bottom: 1.5rem;
  }
</style>
